import { arrayOf, number, oneOf, shape, string } from 'prop-types'

import { PLAN_TYPE } from './constants'

export const planShape = shape({
  planType: oneOf([PLAN_TYPE.YEARLY, PLAN_TYPE.MONTHLY]).isRequired,
  priceCents: number.isRequired,
  currency: string.isRequired,
})

export const plansShape = arrayOf(planShape)
